import React from "react";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
import { projects } from "../data";
import { ThemeSwitcher } from "../ThemeSwitcher";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Portfolio() {
  const themesColor = React.useContext(ThemeSwitcher);
  const [dataProjects] = React.useState(projects);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <Container>
      <Fade bottom>
        <Title>
          <h1>Portfolio</h1>
        </Title>
      </Fade>
      <Fade left>
        <MainContent>
          <Carousel {...settings}>
            {dataProjects.map((el, index) => (
              <Card key={index}>
                <Preview src={`images/project${index + 1}.webp`}></Preview>
                <Content>
                  <h4>{el.title}</h4>
                  <p>{el.desc}</p>
                  <span>{el.start}</span>
                  <a href={el.url}>
                    <ToProjectBtn>Live Demo</ToProjectBtn>
                  </a>
                </Content>
              </Card>
            ))}
          </Carousel>
        </MainContent>
      </Fade>
    </Container>
  );
}

export default Portfolio;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 auto;
  padding: 0;
`;

const Card = styled.div`
  height: calc(100% + 50px);
  width: 100%;
  position: relative;
  display: inline-block;
  background-color: #fff;
  border-radius: 10px;
  margin: 50px;
  height: 590px;
  overflow: hidden;
  font-size: 14px;
  border: .5px solid ${(themesColor) => themesColor.theme.title};
  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;
const Preview = styled.img`
  border-radius: 5px;
  flex: 1 1 auto;
  height: 100%;
  width: 100%;
  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
  }
`;

const Content = styled.div`
  width: calc(100% - 20px);
  height: 100%;
  position: absolute;
  overflow: hidden;
  font-size: 20px;
  top: 0;
  left: 0;
  padding: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  opacity: 0;
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 0.4s ease-in-out;
  color: #fff;

  &:hover {
    opacity: 1;
    transform: translate(0px, 0px) rotate(0deg);
  }

  @media (max-width: 768px) {
    font-size: 12px;
    height: 100%;
    h4 {
      font-size: 12px;
      margin: 0;
    }
  }
`;

const Title = styled.div`
  flex: 1 1 auto;
  font-size: 22px;
  line-height: 1.5;
  margin-bottom: 1.25rem;
`;

const MainContent = styled.div`
  display: flex;
  @media (max-width: 768px) {
    width: 50%;
  }
`;

const ToProjectBtn = styled.button`
  display: inline-block;
  text-decoration: none;
  padding: 7px 14px;
  background: #55198b;
  cursor: pointer;
  border-radius: 5px;
  color: #fff;
  border: none;
  font-size: 14px;
  margin-top: 10px;
  &:hover {
    transition: all 0.5s ease-in 0s;
    background: #f5f11c;
    color: #000;
  }
`;

const Carousel = styled(Slider)`
  .slick-prev,
  .slick-next {
    z-index: 50;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 30px;
    height: 30px;
    transform: initial;
    &:before {
      font-size: 30px;
    }
  }
  @media (max-width: 480px) {
    .slick-dots {
      display: none;
    }
  }
  .slick-dots li button:before {
    color: ${(themesColor) => themesColor.theme.title};
    @media (max-width: 480px) {
      display: none;
    }
  }
  .slick-prev:before,
  .slick-next:before {
    color: ${(themesColor) => themesColor.theme.title};
    @media (max-width: 768px) {
      display: none;
    }
  }
  max-width: 80vw;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 3px;
  }
`;
